import { createApi } from "@reduxjs/toolkit/query/react";
import { getEnv } from "@/env";
import { oktaTokenBaseQuery } from "@/react/services/api";

const RETRIEVE_URL = "/v1/db/get";

export const dbServiceApi = createApi({
  reducerPath: "dbService",
  baseQuery: oktaTokenBaseQuery({ baseUrl: getEnv("VUE_APP_API_URL_DB") }),
  endpoints: (build) => ({
    getDBService: build.query({
      query: (data) => ({
        url: RETRIEVE_URL,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useGetDBServiceQuery } = dbServiceApi;
